<template>
	<div>
		<div v-if="showBannerUpdateLocal" id="cookie-consent-banner-update" class="cookie-consent-banner-update">
			<h3>Cookie settings</h3>
			<p>We use cookies to enhance your browsing experience, including website basic functionality, Google
				Analytics and Google Campaigns. By clicking 'Accept All', you agree to the use of all cookies. You can
				manage your preferences by choosing Preferences below. Please note	that blocking some cookies may affect your site experience and the services we provide.
        <br>Your privacy is important to us.<br> For more information, please read our <router-link to="/cookie-policy" class="links">Cookie Policy</router-link> and our <router-link to="/privacy-policy" class="links">Privacy Policy</router-link>
			</p>
			<button @click="acceptAll"
				class="cookie-consent-button btn-success">Accept All</button>
				<button @click="preferences" class="cookie-consent-button btn-success">Preferences</button>
			<!-- <button @click="rejectAll" class="cookie-consent-button btn-grayscale">Reject All</button> -->
			<div class="cookie-consent-options" v-if="showOptions">
				<div class="cookie-consent-preferances">
					<label>
						<input id="consent-necessary" type="checkbox" v-model="consent.necessary" checked disabled>Necessary
					</label>
					<label>
						<input id="consent-preferences" type="checkbox" v-model="consent.preferences">Preferences
					</label>
					<label>
						<input id="consent-analytics" type="checkbox" v-model="consent.analytics">Analytics
					</label>
					<label>
						<input id="consent-marketing" type="checkbox" v-model="consent.marketing">Marketing
					</label>
				</div>
				<button @click="acceptSome" class="cookie-consent-button btn-outline">Accept selection</button>
				<!-- <button @click="closePreferances" class="cookie-consent-button btn-success">Exit Preferances</button> -->
			</div>
		</div>
		<!-- <div v-if="showBanner" id="cookie-consent-banner" class="cookie-consent-banner">
			<h3>Cookie settings</h3>
			<p>We use cookies to enhance your browsing experience, including website basic functionality, Google
				Analytics and Google Campaigns. By clicking 'Accept All', you agree to the use of all cookies. You can
				manage your preferences by choosing Preferences below. Please note	that blocking some cookies may affect your site experience and the services we provide. For more
				information, please read our <router-link to="/cookie-policy" class="links">Cookie Policy</router-link>.
				<br>Your privacy is important to us.<br>
				For more information please refer to our <router-link to="/privacy-policy" class="links">Privacy Policy</router-link>
			</p>
			<button @click="acceptAll" class="cookie-consent-button btn-success">Accept All</button>
			<button @click="preferences" class="cookie-consent-button btn-success">Preferences</button>
			<div class="cookie-consent-options" v-if="showOptions">
				<div class="cookie-consent-preferances">
					<label><input id="consent-necessary" type="checkbox" value="Necessary" checked disabled>Necessary</label>
					<label><input id="consent-preferences" type="checkbox" value="Preferences" checked>Preferences</label>
					<label><input id="consent-analytics" type="checkbox" value="Analytics" checked>Analytics</label>
					<label><input id="consent-marketing" type="checkbox" value="Marketing" checked>Marketing</label>
				</div>
				<button @click="acceptSome" class="cookie-consent-button btn-outline">Accept selection</button>
				
			</div>
		</div> -->
	</div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'CookieConsentNew',
  props: {
    showBannerProp: Boolean,
  },
  
  data() {
    return {
      showBanner: localStorage.getItem('consentMode') === null,
      showBannerUpdateLocal: this.showBannerProp, // Create a data property based on the prop's value
      showOptions: false,
      consent: {
        necessary: true, // Initial value for "Necessary" checkbox
        analytics: true, // Initial value for "Analytics" checkbox
        preferences: true, // Initial value for "Preferences" checkbox
        marketing: false, // Initial value for "Marketing" checkbox
      },
    };
  },

  watch: {
    showBannerProp(newVal) {
      this.showBannerUpdateLocal = newVal; // Update the data property when the prop changes
    },
  },

  computed: {
    showBannerUpdate: {
      get() {
        return this.showBannerUpdateLocal;
      },
      set(value) {
        this.showBannerUpdateLocal = value;
      },
    },
  },

  methods: {
    hideBanner() {
      this.showBanner = false;
    },
    hideBannerUpdate() {
      this.$emit('update:showBannerProp', false);
    },
    acceptAll() {
      this.consent = {
        necessary: true,
        analytics: true,
        preferences: true,
        marketing: true,
      };
      this.setConsent(this.consent);
      this.hideBanner();
      this.hideBannerUpdate();
      localStorage.setItem('consentMode', JSON.stringify('all'));
    },
    acceptSome() {
      this.setConsent({
        necessary: true,
        analytics: document.getElementById('consent-analytics').checked,
        preferences: document.getElementById('consent-preferences').checked,
        marketing: document.getElementById('consent-marketing').checked,
      });
	    this.setConsent(this.consent);
      this.hideBanner();
      this.hideBannerUpdate();
      this.showOptions = false;
      localStorage.setItem('consentMode', JSON.stringify('some')); 
    },
    setConsent(consent) {
      const consentMode = {
        'functionality_storage': consent.necessary ? 'granted' : 'denied',
        'security_storage': consent.necessary ? 'granted' : 'denied',
        'ad_storage': consent.marketing ? 'granted' : 'denied',
        'analytics_storage': consent.analytics ? 'granted' : 'denied',
        'personalization': consent.preferences ? 'granted' : 'denied',
      };
      Cookies.set('necessary', consent.necessary ? 'true' : 'false', { expires: 365, sameSite: 'Lax', secure: false });
      Cookies.set('analytics', consent.analytics ? 'true' : 'false', { expires: 365, sameSite: 'None', secure: true });
      Cookies.set('preferences', consent.preferences ? 'true' : 'false', { expires: 365, sameSite: 'Lax', secure: false });
      Cookies.set('marketing', consent.marketing ? 'true' : 'false', { expires: 365, sameSite: 'None', secure: true });
      localStorage.setItem('consentMode', JSON.stringify(consentMode));
      
    },
    preferences() {
      this.showOptions = true;
    },
    closePreferances() {
      this.showOptions = false;

    },
  },

  mounted() {
    const necessary = Cookies.get('necessary') === 'true';
    const analytics = Cookies.get('analytics') === 'true';
    const preferences = Cookies.get('preferences') === 'true';
    const marketing = Cookies.get('marketing') === 'true';
    this.consent = {
      necessary,
      analytics,
      preferences,
      marketing,
    };
    
  },

  created() {
    const consentGiven = localStorage.getItem('consentMode');
    if (consentGiven) {
      this.hideBanner();
      this.hideBannerUpdate();
    }
  },
};
</script>